/* eslint-disable */
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import {
  AppBar,
  Box,
  Container,
  Toolbar,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  Divider,
  Paper,
} from "@mui/material";
import styles from "./Header.module.scss";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import LanguageSwitch from "../Inputs/LanguageSwitch/LanguageSwitch";
import ModalComponent from "../Modals/ModalComponent/ModalComponent";
import UserInfoModal from "../Modals/UserInfoModal/UserInfoModal";
import EditPasswordModal from "../Modals/EditPasswordModal/EditPasswordModal";
import { connect } from "react-redux";
import { deauthenticate } from "../../actions/login";
import { getCurrentUser } from "../../actions/users";
import { User } from "../../utils/Authenticate";
import { Headers } from "../../utils/Headers";

function Header({
  currentSystem,
  deauthenticate,
  getCurrentUser,
  currentUser,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [userCredentials, setUserCredentials] = useState({});
  const handleCredentials = async () => {
    const resp = User.loadLocalStorageItems();
    setUserCredentials(resp?.user);
  };
  useEffect(() => {
    handleCredentials();
  }, []);

  const logo = currentSystem?.system?.logo;
  const [openUserInfo, setOpenUserInfo] = useState(false);
  const handleOpenUserInfo = () => setOpenUserInfo(true);
  const handleCloseUserInfo = () => setOpenUserInfo(false);

  const [openEditPassword, setOpenEditPassword] = useState(false);
  const handleOpenEditPassword = () => setOpenEditPassword(true);
  const handleCloseEditPassword = () => setOpenEditPassword(false);
  let location = useLocation();
  useEffect(() => {
    if (location.pathname === "/") {
      setIsActive({ systems: true, users: false });
    } else if (
      location.pathname.includes("users") ||
      location.pathname.includes("profile")
    ) {
      setIsActive({ systems: false, users: true });
    }
  }, [location]);
  const [isActive, setIsActive] = useState({ systems: false, users: false });
  const [anchorElUser, setAnchorElUser] = useState(null);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleLogout = () => {
    // handleCloseUserMenu();
    deauthenticate();
  };

  return (
    <AppBar elevation={2} position="relative" color={"transparent"}>
      <div style={{ padding: window.innerWidth < 900 ? "0px 15px" :"0px 35px" }}>
        <Toolbar disableGutters className={styles["header-toolbar"]}>
          {window.innerWidth > 900 &&
          currentSystem &&
          location.pathname !== "/" &&
          location.pathname !== "/users" &&
          !location.pathname.includes("chat") ? (
            <div style={{ display: "flex", alignItems: "center" }}>
              <ArrowBackIosNewIcon
                style={{ cursor: "pointer" }}
                onClick={() => navigate(-1)}
              />
              {location.pathname.includes("add-users") && (
                <p>{t("app:addUsers")}</p>
              )}
              {location.pathname.includes("system") &&
                !location.pathname.includes("users") &&
                !location.pathname.includes("chat") && (
                  <p>{t("app:helpCenterFor", { name: currentSystem?.system?.name })}</p>
                )}
              {location.pathname.includes("users") &&
                location.pathname.includes("system") &&
                !location.pathname.includes("add-users") && (
                  <p>{t("app:usersInSystem")}</p>
                )}
              {location.pathname.includes("profile") && (
                <p>{t("app:editUser")}</p>
              )}
            </div>
          ) : (
            <img
              style={{ width: "200px", height: "auto" }}
              src="/header-logo.png"
              alt="header-logo"
            />
          )}
          {window.innerWidth > 900 && (
            <div className={styles.tabs}>
              {logo && location.pathname.includes("system") && !location.pathname.includes("chat") ? (
                <img
                  src={logo}
                  alt="app-logo"
                  style={{ width: "135px", height: "auto" }}
                />
              ) : (
                <>
                  <NavLink
                    className={isActive.systems ? styles["active"] : undefined}
                    to="/"
                  >
                    {t("app:systems")}
                  </NavLink>
                  <NavLink
                    className={isActive.users ? styles["active"] : undefined}
                    to="/users"
                  >
                    {t("app:users")}
                  </NavLink>
                </>
              )}
            </div>
          )}

          <IconButton onClick={handleOpenUserMenu}>
            <Avatar
              src={userCredentials?.avatar}
              alt="avatar"
              style={{ border: "0.3px solid #0dc1ce" }}
            />
          </IconButton>
          <Menu
            className={styles["user-menu"]}
            PaperProps={{
              style: {
                width: "400px",
              },
            }}
            MenuListProps={{
              disablePadding: true,
            }}
            id="menu-appbar"
            anchorEl={anchorElUser}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
          >
            <Paper elevation={1} className={styles["menu-options"]}>
              <h3>{t("app:profileSettings")}</h3>
              <CloseIcon
                fontSize="medium"
                onClick={handleCloseUserMenu}
                style={{ cursor: "pointer" }}
              />
            </Paper>
            <div className={styles["user-info"]}>
              <Avatar src={userCredentials?.avatar} alt="avatar" />
              <div>
                <h3>{userCredentials?.name}</h3>
                <p>{userCredentials?.email}</p>
              </div>
            </div>
            {/* Not a MenuItem: those close the menu on click, and switching
                language should leave it open so the change is visible in place.
                Geometry is copied from the MenuItems below (ml:1 + 6px 16px
                padding, 35px icon, 8px gap) so the icons and labels line up. */}
            <Box
              className={styles["menu-item"]}
              sx={{
                // Matches the MenuItems below: ml:1 + 6px/16px padding, and MUI's
                // menu typography, which a plain Box does not inherit.
                ml: 1,
                pl: "28px",
                pr: "16px",
                py: "6px",
                minHeight: "48px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
                fontSize: "1rem",
                fontFamily: (theme) => theme.typography.fontFamily,
              }}
            >
              {/* gap replaces the {" "} the MenuItems use — flex collapses that
                  whitespace, which would pull the label 10px left of theirs. */}
              <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <LanguageOutlinedIcon
                  fontSize="large"
                  style={{ color: "#0DC1CE" }}
                />
                {t("language.label")}
              </Box>
              <LanguageSwitch />
            </Box>
            <MenuItem
              sx={{
                ml: 1,
                "&.MuiButtonBase-root:hover": {
                  bgcolor: "transparent",
                },
              }}
              className={styles["menu-item"]}
              onClick={() => {
                handleOpenUserInfo();
                handleCloseUserMenu();
              }}
            >
              <AccountCircleOutlinedIcon
                fontSize="large"
                style={{ color: "#0DC1CE" }}
              />{" "}
              {t("app:myProfile")}
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleLogout();
              }}
              sx={{
                ml: 1,
                "&.MuiButtonBase-root:hover": {
                  bgcolor: "transparent",
                },
              }}
              className={styles["menu-item"]}
            >
              <LogoutIcon fontSize="large" style={{ color: "#FD416C" }} />{" "}
              {t("app:logout")}
            </MenuItem>
          </Menu>
        </Toolbar>
      </div>
      <ModalComponent
        open={openUserInfo}
        handleClose={handleCloseUserInfo}
        children={
          <UserInfoModal
            getCurrentUser={getCurrentUser}
            userCredentials={userCredentials}
            currentUser={currentUser}
            handleClose={handleCloseUserInfo}
            handleOpenEditPassword={handleOpenEditPassword}
          />
        }
      />
      <ModalComponent
        open={openEditPassword}
        handleClose={handleCloseEditPassword}
        children={
          <EditPasswordModal
            currentUser={userCredentials}
            handleClose={handleCloseEditPassword}
          />
        }
      />
    </AppBar>
  );
}
const mapDispatchToProps = (dispatch) => ({
  deauthenticate: () => dispatch(deauthenticate()),
  getCurrentUser: (payload) => dispatch(getCurrentUser(payload)),
});

const mapStateToProps = (state) => ({
  currentSystem: state.systems.currentSystem,
  currentUser: state.users.currentUser,
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
